exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-headerfrm[data-v-13cfc98c] {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: white;\n  border-bottom: 1px solid #c2cfd6;\n  border-color: white;\n}\n.position[data-v-13cfc98c] {\n  position: absolute;\n  right: 10px;\n  top: 46px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13cfc98c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/sr/rejectreasonmaster/rejectreasonmaster.component.scss
// module id = 1619
// module chunks = 0